var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section parallax",style:(_vm.style)},[_vm._t("default"),_vm._v(" "),(_vm.hasCaption)?_c('div',{staticClass:"caption",domProps:{"textContent":_vm._s(_vm.caption)}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }